import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const InputTime = styled.div`
  width: 100%;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

export const Label = styled.label`
  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 500;
  margin-bottom: 4px;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  height: 38px;
  padding: 0 12px;
  background-color: ${Colors.Input_Color_1};
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;
  color: ${Colors.text_Color_1};
  font-size: 0.7em;
  font-weight: 300;
  transition: border 300ms ease-in-out;
  outline: none;

  &::placeholder {
    color: ${localStorage.getItem('tema') === 'E' ? 'rgb(255 255 255 / 0.5)' : Colors.text_Color_1};
  }

  &:hover {
    border: 1px solid rgb(255 255 255 / 0.25);
  }

  &:focus {
    border: 1px solid rgb(255 255 255 / 0.4);
  }

  &:disabled {
    cursor: not-allowed;
    /* background-color: rgb(255 255 255 / 0.05); */
  }

  &:read-only {
    opacity: 0.5;
  }
`;

export const Error = styled.span`
  color: ${Colors.ftColor6};
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;
